// extracted by mini-css-extract-plugin
module.exports = {"roleType":"_1Bk89AVh","cellClick":"_3vvV3xb1","linkClick":"_1EHYGd52"};